import React from 'react';
import {
  FormControl,
  FormLabel,
  Icon,
  InputGroup,
  InputRightElement,
  Tooltip,
} from '@chakra-ui/react';
import { FiHelpCircle, FiX } from 'react-icons/fi';
import { BsFillInfoCircleFill, FiCheck } from 'react-icons/all';
import { useForm } from 'react-hook-form';
import { Input } from '~/components/Input';

type InputNewValueProps = {
  label?: string;
  textoInformativo?: string;
  placeholder?: string;
  salvarValor: (valor: string) => void;
  esconderInput: () => void;
  value?: string;
  limiteCaracteres?: number;
};

export const InputNewValue: React.VFC<InputNewValueProps> = ({
  label = '',
  textoInformativo = '',
  placeholder = '',
  salvarValor,
  esconderInput,
  value = '',
  limiteCaracteres = 0,
}) => {
  const [valor, setValor] = React.useState(value);
  const { formState, setValue, reset, setError, clearErrors } = useForm();
  const { errors } = formState;

  const limpaValor = () => {
    setValor('');
  };

  const escondeInput = () => {
    limpaValor();
    esconderInput();
  };

  const salvaValor = () => {
    if (valor.trim() === '') {
      setError('valor', {
        type: 'required',
        message: 'Campo obrigatório',
      });
      return;
    }
    if (limiteCaracteres && valor.length > limiteCaracteres) {
      setError('valor', {
        type: 'maxLength',
        message: `O campo deve ter no máximo ${limiteCaracteres} caracteres`,
      });
      return;
    }
    salvarValor(valor.trim());
    limpaValor();
  };

  const onChangeValor = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValor(e.target.value);
    clearErrors();
  };

  return (
    <FormControl isInvalid={errors.valor} width="100%">
      {label && (
        <FormLabel
          style={{ fontSize: '14px' }}
          justifyContent="space-between"
          display="flex"
        >
          {label}
          {textoInformativo && (
            <Tooltip
              hasArrow
              label={textoInformativo}
              bg="gray"
              shouldWrapChildren
            >
              <Icon as={BsFillInfoCircleFill} />
            </Tooltip>
          )}
        </FormLabel>
      )}
      <InputGroup>
        <InputRightElement
          pointerEvents="auto"
          justifyContent="space-evenly"
          width="80px"
        >
          <Icon
            as={FiCheck}
            style={{
              cursor: 'pointer',
            }}
            onClick={salvaValor}
            fontSize={20}
            fontWeight="bolder"
          />
          <Icon
            as={FiX}
            style={{
              cursor: 'pointer',
            }}
            onClick={escondeInput}
            fontSize={20}
            fontWeight="bolder"
          />
        </InputRightElement>
        <Input
          placeholder={placeholder}
          value={valor}
          name="valor"
          style={{ paddingRight: '80px' }}
          error={errors.valor}
          onChange={e => onChangeValor(e)}
        />
      </InputGroup>
    </FormControl>
  );
};
